import React from "react";
import StageList from "./StageList";

export default function Hired() {
  return (
    <StageList
      stage="hired"
      title="Hired"
      subtitle="Onboarding pipeline — accepted offers"
      actions={[]}
    />
  );
}
